import * as ng from 'angular';

export class ContractStep1Controller implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$sce',
        'store',
        '$state',
        'contractHtml'
    ];

    constructor(
        private $scope: any,
        private $sce: any,
        private store: ng.a0.storage.IStoreService,
        private $state: ng.ui.IStateService,
        private contractHtml: any
    ) {
        $scope.user = store.get('registeringUser');
        $scope.buttonDisabled = false;
        $scope.confirmCheckbox = false;

        if (contractHtml !== null && contractHtml !== undefined) {
            $scope.contractHtmlHeader = $sce.trustAsHtml(contractHtml.header);
            $scope.contractHtmlBody = $sce.trustAsHtml(contractHtml.body);
        }

        $scope.next = () => {
            $scope.buttonDisabled = true;
            $state.go('registration.contract-step2');
        };

        $scope.prev = () => {
            store.set('registeringUser', $scope.user);

            if ($scope.user.accountData.userType === 1) {
                $state.go('registration.organization-data-lp');
            } else {
                $state.go('registration.organization-data');
            }
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/contract-step1/contract-step1.controller.ts